import './dsFocus.js';

/**
 * Toggle — the design system's on/off switch.
 *
 * The NAME and the prop set are not a choice: the adherence gate already ships a
 * selector for this component (`.oxlintrc.adherence.json`, selector 38 — «<Toggle>
 * doesn't accept that prop. Declared props: on, disabled, onChange, style.»), so the
 * switch the card needs is this one, built from tokens the way Chip was. Consumers may
 * therefore pass ONLY `on` / `disabled` / `onChange` / `children` / `className` /
 * `style` — a tooltip belongs on a wrapping element, never on the switch.
 *
 * `onChange` is called with the NEXT state, so a caller never re-derives it:
 * `onChange={(next) => mutate({ enabled: next })}`. The rendered element is a real
 * `<button role="switch">` with `aria-checked`, which is what makes the control
 * keyboard-operable without a hidden input.
 *
 * Focus ring: shared, via data-ds-focusable (spec S8).
 */
export function Toggle ({ on = false, disabled = false, onChange, children, className, ...rest }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      disabled={disabled}
      data-ds-focusable
      className={['oc-toggle', on && 'oc-toggle--on', className].filter(Boolean).join(' ')}
      onClick={(e) => onChange?.(!on, e)}
      {...rest}
    >
      <span className="oc-toggle__track" aria-hidden="true">
        <span className="oc-toggle__thumb" />
      </span>
      {children != null && <span className="oc-toggle__label">{children}</span>}
    </button>
  );
}
